export default "dist/images/block-call-to-action-horizontal-2.877c219.png";